import { connect } from 'react-redux';

import { getLastErrorStatus } from 'helpers/http';
import { isRedirectingToLogin as readRedirectFlag } from 'helpers/session-auth-redirect';
import { selectUserIsLoaded, selectUserIsAuthenticated } from 'selectors/general';
import { selectDesktopNavIsCollapsed } from 'features/Sidenav/selectors';

import PageLayout from './PageLayout';

const mapStateToProps = (state, ownProps) => ({
  // Suppress the InternalError overlay while we're redirecting to /login —
  // the user is leaving the page anyway, no point flashing "we'll be back soon".
  hasInternalError: getLastErrorStatus() && !readRedirectFlag(),
  isAuthenticated: selectUserIsAuthenticated(state),
  shouldDisplay: ownProps.isPublic || selectUserIsLoaded(state),
  sidenavCollapsed: selectDesktopNavIsCollapsed(state),
});

export default connect(mapStateToProps)(PageLayout);
